export enum AuditLogEvents {
  EntityCreated = "entity_created",
  EntityUpdated = "entity_updated",
  EntityDeleted = "entity_deleted",
}
